<template>
  <div class="shell">
    <div class="policy">
      <div class="policyTitle">
        <div class="title-name">
          电子投保单
        </div>
      </div>
      <div v-if="!policyTitle" class="policyBody">
        <p class="policy-clause" @click="toDetail(item.downLoadUrl)"  v-for="item in ePolicyDtoObj" :key="item.riskName">
          {{ item.riskName }}
          <!-- <wx-open-launch-weapp
            v-if="isAPP"
            id="launch-btn"
             username="gh_a61d04a74613"
            :path="ePolicyDtoObj.path"
          >
            <script type="text/wxtag-template">
              <style>.wx_btn{
              width:100%;
              height:40px;
              opacity:0;
              }
              </style>
              <button class="wx_btn">
              查看车险电子投保单
              </button>
            </script>
          </wx-open-launch-weapp> -->
        </p>
      </div>
      <div v-if="policyTitle" class="policyBody">
        <p class="policy-clause">
          暂无订单
        </p>
      </div>
    </div>
    <Loading :switchs="switchs" />
  </div>
</template>

<script>
import api from '@/api/api.js'
import Loading from '@/components/Loadings/Loading'
// import checkFormat from '@/utils/checkFormat.js'
export default {
  components: {
    Loading
  },
  data() {
    return {
      appId: process.env.ENV_CONFIG === 'prod' ? 'wxd0dbfed69fd5c110' : 'wxf76ae40637a27dda',
      switchs: false, // loading
      orderId: this.$route.query.orderId || '',
      orderNo: this.$route.query.orderNo || '',
      token: this.$route.query.token || '',
      channelCode: this.$route.query.channelCode || '',
      ePolicyDtoObj: {
        riskName: '',
        path: ''
      }, // pdf地址数据
      policyTitle: false,
      path: 'pages/pdf/pdf.html?pdfUrl=',
      isAPP: false,
      productCode: '',
      endorseNo: this.$route.query.endorseNo || '',
      encryptKey: this.$route.query.encryptKey || '',
      orderEncryptKey: this.$route.query.orderEncryptKey || '',
      businessObj: {},
      trafficObj: {},
      num: 1 // 次数
    }
  },
  mounted() {
    this.getWxTicket()
    this.getOrderDetail()
  },
  methods: {
    getWxTicket() {
      const shareParam = {
        url: window.location.href.split('#')[0],
        wxType: '5'
      }
      this.$http.post(api.getWxTicket, shareParam).then((res) => {
        wx.config({
          // beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: this.appId, // 必填，企业微信的corpID
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
          jsApiList: ['wx-open-launch-weapp'], // 必填，随意一个接口即可
          openTagList: ['wx-open-launch-weapp'] // 填入打开小程序的开放标签名
        })
      })
    },
    // 获取订单详情
    getOrderDetail() {
      if (this.orderId && this.orderNo && this.token) {
        const data = {
          fileContentFlag: '0',
          orderId: this.orderId
        }
        this.switchs = true
        this.$http.post(api.queryOrderDetail_ZSB, data).then(res => {
          if (res.data.rtnCode === '0000') {
            if (res.data.data && res.data.data.oldDetail.resultObj.productCode) {
              this.productCode = res.data.data.oldDetail.resultObj.productCode
            }
            const policyList = res.data.data.oldDetail.resultObj.orderPolicyList
            if (policyList && policyList.length > 0) {
              const map = new Map()
              const newElePolicy = policyList.filter(el => !map.has(el.typeCode) && map.set(el.typeCode, el))
              this.businessObj = newElePolicy.filter(el => el.typeCode === '050A' || el.typeCode === '050B')
              this.trafficObj = newElePolicy.filter(el => el.typeCode === '0590' || el.typeCode === '0591')
              console.log(this.trafficObj, 'this.trafficObj')
              console.log(this.businessObj, 'this.businessObj')
              if (this.businessObj && this.businessObj.length > 0 && this.businessObj[0].policyNo) {
                this.getElePolicy(this.businessObj[0].typeCode, this.businessObj[0].policyNo, '1')
              } else {
                if (this.trafficObj && this.trafficObj.length > 0 && this.trafficObj[0].policyNo) {
                  this.getElePolicy(this.trafficObj[0].typeCode, this.trafficObj[0].policyNo, '2')
                } else {
                  this.switchs = false
                }
              }
            } else {
              this.policyTitle = true
              this.switchs = false
            }
          } else {
            this.switchs = false
            this.$toast(res.data.rtnMsg)
          }
          this.getWebApp(this.productCode)
        })
      }
    },
    /*
      优先使用商业险保单号查询，若商业险保单号为空则取交强险保单号查询，若查不到结果，在页面展示：未查询到电子投保单。
    */
    getElePolicy(riskCode, policyNo, flag) {
      console.log(flag, 'flag')
      const riskNames = riskCode === '050A' || riskCode === '0590' ? '车险' : '摩托车'
      const ePolicyDtoObj = [
        {
          riskName: riskNames + '电子投保单',
          downLoadUrl: '',
          policyNo: policyNo,
          integration: true,
        },
        {
          riskName: riskNames + '电子投保单（不含提示声明等）',
          downLoadUrl: '',
          policyNo: policyNo,
          integration: false
        }
      ] // pdf地址数据
      console.log(ePolicyDtoObj, 'ePolicyDtoObj')
      let allPromises = ePolicyDtoObj.map(element =>
        this.$http.post(api.getElectronic, {
          businessNo: element.policyNo,
          riskCode: element.riskCode,
          integration: element.integration
        }).then(res => {
          console.log(res.data, 'res')
          if (res.data.rtnCode === '0000') {
            this.switchs = false
            element.downLoadUrl = res.data.fileUrl
            this.ePolicyDtoObj = ePolicyDtoObj
            console.log(this.ePolicyDtoObj, 'ePolicyDtoObj')
          } else {
            this.ePolicyDtoObj = []
            this.policyTitle = true
            this.switchs = false
            // if (flag === '1' && this.num > 0) {
            //   this.getElePolicy(this.trafficObj[0].riskCode, this.trafficObj[0].policyNo, '2')
            //   this.num --
            // } else {
            //   this.ePolicyDtoObj = []
            //   this.policyTitle = true
            //   this.switchs = false
            // }
          }
        }).catch(error => {
          console.log(error, 'err')
          return Promise.reject(error)
        })
      )
      Promise.all(allPromises).catch(error => {
        console.error('所有请求完成，其中一个失败:', error)
        if (error) {
          this.$toast('/vehicle-non-integration 请求失败')
        }
      })
    },
    /**
     * 微信小程序打开：车险移动端IOS微信、摩托车险移动端微信
     * 原生打开：车险移动端安卓微信、车险PC端、摩托车PC端、非车险
     *  */
    getWebApp(productCode) {
      const environment = this.getIsWxClient()// 判断是否微信环境
      const mobileEnv = this.getIsMobileClient()// 判断是否手机环境
      const iosEnv = this.getIsIos()// 判断是否ios环境
      if (environment) {
        if (iosEnv && mobileEnv) {
          this.isAPP = true
        } else {
          productCode === 'motor_product' && mobileEnv ? (this.isAPP = true) : (this.isAPP = false)
        }
      } else {
        this.isAPP = false
      }
    },
    // 判断是否微信环境
    getIsWxClient() {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i).length > 0 && ua.match(/MicroMessenger/i) == 'micromessenger') {
        console.log('微信环境')
        return true
      }
      return false
    },
    // 判断是否手机环境
    getIsMobileClient() {
      const ua = navigator.userAgent.toLowerCase()
      if (/mobile/i.test(ua)) {
        console.log('手机环境')
        return true
      }
      return false
    },
    // 判断是否ios环境
    getIsIos() {
      const ua = navigator.userAgent.toLowerCase()
      const isIos = !!ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/)
      console.log(isIos, '是否IOS')
      return isIos
    },
    toDetail(downLoadUrl) {
      console.log(downLoadUrl, 'this.ePolicyDtoObj.downLoadUrl')
      // window.open(downLoadUrl)
      window.location.href = downLoadUrl
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/pages/Pdf/elePolicy/index.vue